export default class RicambioAttivita{
    CheckMagazzino;
    DescrizioneMagazzino;
    CodiceArticolo;
    DescrizioneArticolo;
    UnitaMisura;
    QtaPrevista;
    QtaEffettiva;
    CodiceMagazzino;
    Incluso;
    SysChiaveglobale;

    constructor(){}
}